import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { CookieService } from 'ngx-cookie';
import { AppService } from '../../../app.service';
import { SwitchService } from '../../switch/switch.service';
import { ErrorService } from '../../error/error.service';
import { ActivatedRoute } from '@angular/router';
import { AccessibilityService } from '../../../services/accessibility.service';
import { PaymentSelectionComponent } from '../../eb/paymentSelection.component';
import { AuthService } from '@auth0/auth0-angular';
import { UtilService } from 'src/app/util.service';
declare let $: any;

@Component({
  selector: 'app-eb-login',
  templateUrl: './eb-login.component.html'
})
export class EbLoginComponent implements OnInit {
  private subscription: Subscription;
  private activateCustomer;
  public userName: any;
  public showEBforPointsBuy = false;  

  @Output()
  connectToWifi: EventEmitter<any> = new EventEmitter();

  constructor(
    private cookieService: CookieService,
    private appService: AppService,
    private switchService: SwitchService,
    private accessibilityService: AccessibilityService,
    private activatedRoute: ActivatedRoute,
    private authService:AuthService,
    private utils: UtilService,
    private errorService: ErrorService) {
    this.logoutCustomer();
  }

  ngOnInit() {
    this.showEBforPointsBuy = PaymentSelectionComponent.showEBforPointsBuy;
    this.userName = undefined;
    this.activatedRoute.queryParams.subscribe(params => {
      if (params && (params.username)) {
        this.userName = params.username;
      } else if (params && (!params.pnr && !params.firstname && !params.lastname)) {
        this.accessibilityService.focus('#activate-header');
      }
    });

  }

  private onLogInSucess(err: any, response: any) {
    const loaderTextList = { loaderHeaderText: 'loaderText' };
    this.appService.showLoaderWithText(loaderTextList);
    if (err) {
      const despError = [{ 'type': 'despOnly', 'desp': err.responseJSON.error_description }];
      this.errorService.addError(despError);
      this.appService.hideLoaderWithText();
    } else if (response) {
      this.switchService.setLoginFromActivate(true);
      this.connectToWifi.emit();
    } else {
      this.activateCustomer.logout();
      this.authService.logout();
      this.utils.newEBUserLogout();
      this.appService.hideLoaderWithText();
    }
  }

  private onAccountInfoSucess() {
  }

  ngAfterViewInit() {    
    this.appService.loadCustJs(this, ()  =>  {
      let customerConfig = {
        lang: this.appService.getLanguage(),
        market: this.appService.getPOS(),
        loginCallback: (err: any, response: any) => this.onLogInSucess(err, response),
        accountInfoCallback: () => this.onAccountInfoSucess(),
        userEmail: this.userName,
        wifiActivate: true,   
        showEBPoints: this.showEBforPointsBuy,     
        skinCode: false
      }
      this.activateCustomer = new (window as any).Customer('#activate-login', customerConfig);
      this.activateCustomer.show();      
    });    
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    if (this.subscription !== undefined) {
      this.subscription.unsubscribe();
    }
  }

  private logoutCustomer() {
    this.subscription = this.appService.activateCustomerLogoutObservable.subscribe(
      value => {
        if (value) {
          this.activateCustomer.logout();
        }
      });
  }

}
